import React, { useEffect, useState } from "react";
import { set, useFieldArray, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import { getDoctorDetailAPI } from "../../api/doctor";
import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../assets/constants";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  OverlineTitle,
  Row,
  Sidebar,
  TooltipComponent,
  UserAvatar,
} from "../../components/Component";
import { Badge, Card, Form, FormGroup, Input, Spinner } from "reactstrap";
import { findUpper, getSmartInitials } from "../../utils/Utils";
import useLogout from "../../hooks/useLogout";
import { getDoctorAppointmentsAPI } from "../../api/master/indes";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import DataTable from "react-data-table-component";
import moment from "moment";

const DoctorDetailsView = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      debounceLoading: false,

      stateList: [],
      cityList: [],
      specializationDD: [],

      profile_image: null,
      profile_img: null,

      pan_image: null,
      pan_img: null,

      cert_image: null,
      cert_img: null,

      aadhaar_f_image: null,
      aadhaar_f_img: null,

      aadhaar_b_image: null,
      aadhaar_b_img: null,
      qualifications: [
        {
          degree: "",
          passing_year: "",
          certificate_no: "",
          university: "",
          certificate: null,
          certificate_url: null,
          referral_code: null,
        },
      ],
    },
  });
  const [appointments, setAppointments] = useState([]);
  const [showModal, setShowModal] = useState([]);
  const logout = useLogout();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "qualifications",
  });
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("personal");
  const [sideBar, setSidebar] = useState(false);
  // function to toggle sidebar
  const toggle = () => {
    setSidebar(!sideBar);
  };
  useEffect(() => {
    sideBar ? document.body.classList.add("toggle-shown") : document.body.classList.remove("toggle-shown");
  }, [sideBar]);
  console.log("location", location);
  useEffect(() => {
    if (!location?.state?.doctorId) return;

    const body = {
      doctorId: location.state.doctorId,
    };

    getDrDetails(body);
  }, [location?.state?.doctorId]);

  const getDrDetails = (body) => {
    getDoctorDetailAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("doctorDetail", res.data.data);
          const doctor = res.data.data;
          setValue("isLoading", false);
          setValue("bio", doctor?.about);
          setValue("referral_code", doctor?.refferal_code || null);
          setValue("name", doctor?.name || null);
          setValue("email", doctor?.email || null);
          setValue("mobile", doctor?.mobile || null);
          setValue("alt_mobile", doctor?.phone_consult || null);
          setValue("experience", doctor?.experience || null);
          setValue("isSelected", doctor?.isSelected || false);
          setValue("registration", doctor?.registration_no || null);
          const gen = [
            { value: "male", label: "Male" },
            { value: "female", label: "Female" },
            { value: "other", label: "Other" },
          ].find((item) => item.value == doctor?.gender);
          setValue("gender", gen || null);
          setValue("state", doctor?.state || null);
          setValue("city", doctor?.city || null);
          setValue("pin_code", doctor?.pin_code || null);
          setValue("specialization", doctor?.specialization || null);
          if (doctor?.known_language) {
            const tagArray = doctor?.known_language?.map((tag) => {
              const trimmed = tag.trim();
              return {
                label: trimmed,
                value: trimmed,
              };
            });

            setValue("known_language", tagArray);
          }
          setValue("address", doctor?.address || null);
          setValue("aadhaar_f_image", doctor?.addhar_front_image || null);
          setValue("aadhaar_b_image", doctor?.addhar_back_image || null);
          setValue("profile_image", doctor?.profile_image || null);
          setValue("pan_image", doctor?.pan_no || null);
          setValue("cert_image", doctor?.cert_image || null);
          setValue("dob", new Date(doctor?.dob || null));
          setValue("year_of_completion", new Date(doctor?.year_of_completion || null));
          doctor?.qualification_data?.forEach((item, index) => {
            // Ensure enough fields exist
            if (index > 0) {
              append({
                degree: "",
                passing_year: "",
                certificate_no: "",
                university: "",
                certificate: null,
                certificate_url: null,
                referral_code: null,
              });
            }
            setValue(`qualifications[${index}].degree`, item.degree);
            setValue(`qualifications[${index}].passing_year`, new Date(item.passing_year));
            setValue(`qualifications[${index}].university`, item.university);
            setValue(`qualifications[${index}].certificate_no`, item.certificate_no);
            setValue(`qualifications[${index}].certificate`, item.certificate || "");
            setValue(`qualifications[${index}].certificate_url`, item.certificate || "");
            if (item.certificate_type) {
              setValue(`qualifications[${index}].certificate_type`, item.certificate_type);
            }
          });

          const avail = [
            { value: "Monthly", label: "Monthly" },
            { value: "Weekdays", label: "Weekdays" },
            { value: "Weekends", label: "Weekends" },
          ].find((item) => item.value == doctor?.availability);
          setValue("show_availability", avail || null);
          setValue("online_consultation_fees", doctor?.online_consultation_fees || null);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("doctorDetail", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const doctor = watch("doctorDetail");
  const [columns, setColumns] = useState([
    {
      name: "Appointment ID",
      selector: (row) => row?.appointment_number,
      sortable: true,
    },
    // {
    //   name: "Patient Name",
    //   selector: (row) => row?.patientName,
    //   cell: (row) => row?.patientName,
    //   sortable: true,
    // },
    {
      name: "Patient Name",
      selector: (row) => row?.name,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "6px 0",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontWeight: 600,
                fontSize: "15px",
                color: "#111827",
                lineHeight: "1.2",
              }}
            >
              {row?.patientName || "N/A"}
            </span>
            <span
              style={{
                fontSize: "13px",
                color: "#6b7280",
              }}
            >
              {row?.mobile || "N/A"}
            </span>
          </div>
        </div>
      ),
      sortable: true,
      // width: "250px",
    },
    {
      name: "Booking Type",
      selector: (row) => row?.booking_type,
      cell: (row) => (
        <span className="text-capitalize">
          <Badge color={`${row?.booking_type == "online" ? "info" : "gray"}`}>{row?.booking_type}</Badge>
        </span>
      ),
      sortable: true,
    },
    {
      name: "Appointment Date",
      selector: (row) => row?.date,
      cell: (row) => (
        <span className="text-capitalize">
          {moment(row?.date).format("DD-MM-YYYY")}
          {row?.booking_type === "online" ? ` - ${row?.start_time}` : ""}
        </span>
      ),
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div className="text-capitalize" style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status == "completed" ? "success" : row?.status == "cancelled" ? "danger" : "warning"}`}>
            {row.status}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,

      // width: "220px",
    },
  ]);
  const [isLoadingTable, setLoadingTable] = useState(false);
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const tabChange = (tabName) => {
    setActiveTab(tabName);
    if (tabName == "appointments") {
      const body = {
        doctorId: location.state.doctorId,
      };
      setLoadingTable(true);
      console.log("hit api for appointment");
      getDoctorAppointmentsAPI(body)
        .then((res) => {
          const status = res?.data?.status;
          console.log("okoko", res.data);

          if (status === true) {
            setAppointments(res?.data?.data || []);

            setLoadingTable(false);
          } else if (status === "expired") {
            toast.error(res.data.message);
            logout();
          } else if (status === false) {
            setAppointments([]);
            setLoadingTable(false);
            toast.error(res?.data?.message);
          }
        })
        .catch((err) => {
          console.error("Add top doctors error:", err);
          toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          setLoadingTable(false);
        });
    }
    if (tabName == "slots") {
      console.log("hit api for slots");
      navigate("/doctor/slot-management", { state: { data: watch("doctorDetail") } });
    }
  };
  const [filterText, setFilterText] = useState("");
  const filteredData = appointments?.filter((item) =>
    Object?.values(item)?.some(
      (value) => typeof value === "string" && value.toLowerCase().includes(filterText.toLowerCase()),
    ),
  );
  console.log("doctor,", doctor);

  return (
    <>
      <Head title={"Doctor Detail"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Doctor / <strong className="text-primary small text-capitalize">{doctor?.name || ""}</strong>
              </BlockTitle>
              <BlockDes className="text-soft">
                <ul className="list-inline">
                  <li>
                    User ID: <span className="text-base">UD003054</span>
                  </li>
                  <li>
                    Last Login: <span className="text-base">{doctor?.lastLogin || ""} 01:02 PM</span>
                  </li>
                </ul>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button color="primary" outline className={`  me-n1`} onClick={() => navigate(-1)}>
                <Icon name="arrow-left"></Icon>
                <span>Back</span>
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Card>
            <div className="card-aside-wrap" id="user-detail-block">
              <div className="card-content">
                <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
                  <li className="nav-item">
                    <a
                      className={`nav-link  ${activeTab == "personal" ? "active" : ""}`}
                      href="#personal"
                      onClick={(ev) => {
                        ev.preventDefault();
                        tabChange("personal");
                      }}
                    >
                      <Icon name="user-circle"></Icon>
                      <span>Personal</span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link  ${activeTab == "qualification" ? "active" : ""}`}
                      href="#qualification"
                      onClick={(ev) => {
                        ev.preventDefault();
                        tabChange("qualification");
                      }}
                    >
                      <Icon name="award"></Icon>
                      <span>Qualification</span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link  ${activeTab == "appointments" ? "active" : ""}`}
                      href="#appointments"
                      onClick={(ev) => {
                        ev.preventDefault();
                        tabChange("appointments");
                      }}
                    >
                      <Icon name="list"></Icon>
                      <span>Appointments</span>
                    </a>
                  </li>
                  {/* <li className="nav-item">
                    <a
                      className={`nav-link  ${activeTab == "documents" ? "active" : ""}`}
                      href="#documents"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setActiveTab("documents");
                      }}
                    >
                      <Icon name="file-text"></Icon>
                      <span>Documents</span>
                    </a>
                  </li> */}
                  <li className="nav-item">
                    <a
                      className={`nav-link  ${activeTab == "slots" ? "active" : ""}`}
                      href="#slots"
                      onClick={(ev) => {
                        ev.preventDefault();
                        tabChange("slots");
                      }}
                    >
                      <Icon name="file-text"></Icon>
                      <span>Slots</span>
                    </a>
                  </li>

                  {/* <li className="nav-item nav-item-trigger d-xxl-none">
                                              <Button className={`toggle btn-icon btn-trigger ${sideBar && "active"}`} onClick={toggle}>
                                                <Icon name="user-list-fill"></Icon>
                                              </Button>
                                            </li> */}
                </ul>
                <div className="card-inner">
                  {activeTab == "personal" && (
                    <>
                      <Block>
                        <BlockHead>
                          <BlockTitle tag="h5">Personal Information</BlockTitle>
                        </BlockHead>
                        <div className="profile-ud-list">
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Title</span>
                              <span className="profile-ud-value">Dr.</span>
                            </div>
                          </div>
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Full Name</span>
                              <span className="profile-ud-value text-capitalize">{doctor?.name}</span>
                            </div>
                          </div>
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Date of Birth</span>
                              <span className="profile-ud-value">{doctor?.dob}</span>
                            </div>
                          </div>
                          {/* <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Surname</span>
                              <span className="profile-ud-value">{doctor?.name?.split(" ")[1]}</span>
                            </div>
                          </div> */}
                          <div className="profile-ud-item ">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Mobile Number</span>
                              <span className="profile-ud-value">{doctor?.mobile}</span>
                            </div>
                          </div>
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Email Address</span>
                              <span className="profile-ud-value">{doctor?.email}</span>
                            </div>
                          </div>
                        </div>
                      </Block>
                      {/* <Block>
                        <BlockHead className="nk-block-head-line">
                          <BlockTitle tag="h6" className="overline-title text-base">
                            Additional Information
                          </BlockTitle>
                        </BlockHead>
                        <div className="profile-ud-list">
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Joining Date</span>
                              <span className="profile-ud-value">{doctor?.yearCompletion}</span>
                            </div>
                          </div>
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">Reg Method</span>
                              <span className="profile-ud-value">Email</span>
                            </div>
                          </div>
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">City</span>
                              <span className="profile-ud-value">{doctor?.city?.label}</span>
                            </div>
                          </div>
                          <div className="profile-ud-item">
                            <div className="profile-ud wider">
                              <span className="profile-ud-label">State</span>
                              <span className="profile-ud-value">{doctor?.state?.label}</span>
                            </div>
                          </div>
                        </div>
                      </Block> */}
                      <div className="nk-divider divider md"></div>
                    </>
                  )}
                  {activeTab == "qualification" && (
                    <Block>
                      <BlockHead>
                        <BlockTitle tag="h5">Personal Qualification</BlockTitle>
                      </BlockHead>

                      <div className="profile-ud-list">
                        {doctor?.qualifications?.length > 0 &&
                          doctor.qualifications.map((q, index) => (
                            <div key={q.id || index} className="row g-3 ">
                              <div className="profile-ud-item">
                                <div className="profile-ud wider">
                                  <span className="profile-ud-label">Degree</span>
                                  <span className="profile-ud-value">{q.degree}</span>
                                </div>
                              </div>

                              <div className="profile-ud-item">
                                <div className="profile-ud wider">
                                  <span className="profile-ud-label">year of completion</span>
                                  <span className="profile-ud-value">{q.yearCompletion}</span>
                                </div>
                              </div>

                              <div className="profile-ud-item">
                                <div className="profile-ud wider">
                                  <span className="profile-ud-label">Institute</span>
                                  <span className="profile-ud-value">{q.institute}</span>
                                </div>
                              </div>
                            </div>
                          ))}

                        {/* Contact Info */}

                        <div className="profile-ud-item ps-5">
                          <div className="profile-ud wider">
                            <span className="profile-ud-label">Mobile Number</span>
                            <span className="profile-ud-value">{doctor?.mobile}</span>
                          </div>
                        </div>

                        <div className="profile-ud-item">
                          <div className="profile-ud wider">
                            <span className="profile-ud-label">Email Address</span>
                            <span className="profile-ud-value">{doctor?.email}</span>
                          </div>
                        </div>

                        {/* Experience */}
                        <BlockTitle tag="h6" className="overline-title text-base ms-5 mt-5">
                          Experience
                        </BlockTitle>
                        <div className="nk-divider divider md"></div>

                        {doctor?.experience?.length > 0 &&
                          doctor.experience.map((exp, index) => (
                            <div key={exp.id || index} className="row g-3 ">
                              <div className="profile-ud-item">
                                <div className="profile-ud wider">
                                  <span className="profile-ud-label">Organization</span>
                                  <span className="profile-ud-value">{exp.organization}</span>
                                </div>
                              </div>

                              <div className="profile-ud-item">
                                <div className="profile-ud wider">
                                  <span className="profile-ud-label ms-4"> position</span>
                                  <span className="profile-ud-value">{exp.position}</span>
                                </div>
                              </div>

                              <div className="profile-ud-item">
                                <div className="profile-ud wider">
                                  <span className="profile-ud-label">Duration</span>
                                  <span className="profile-ud-value">
                                    {exp.startDate} – {exp.isPresent ? "Present" : exp.endDate}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                      {/* Specialization */}
                      <BlockTitle tag="h6" className="overline-title text-base mt-5">
                        Specialization
                      </BlockTitle>
                      <div className="nk-divider divider md"></div>

                      <div className="profile-ud-list">
                        {doctor?.specialization?.length > 0 ? (
                          doctor.specialization.map((spec, index) => (
                            <div key={index} className="profile-ud-item">
                              <div className="profile-ud wider">
                                <span className="profile-ud-label">Specialization {index + 1}</span>
                                <span className="profile-ud-value">{spec}</span>
                              </div>
                            </div>
                          ))
                        ) : (
                          <span className="text-muted">No specialization available</span>
                        )}
                      </div>
                    </Block>
                  )}
                  {activeTab == "documents" && (
                    <Block>
                      <BlockHead>
                        <BlockTitle tag="h5">Personal Documents</BlockTitle>
                      </BlockHead>
                    </Block>
                  )}
                  {activeTab == "appointments" && (
                    <Block>
                      {/* <BlockHead>
                        <BlockTitle tag="h5">Appointments</BlockTitle>
                      </BlockHead> */}

                      <div className="data-table-container">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="search-box d-flex justify-content-end">
                            <Form className="theme-form">
                              <FormGroup className="form-group d-flex align-items-center">
                                <Input
                                  className="form-control"
                                  type="text"
                                  placeholder="Search..."
                                  value={filterText}
                                  onChange={(e) => setFilterText(e.target.value)}
                                />
                                <i className="fa fa-search ms-2"></i>
                              </FormGroup>
                            </Form>
                          </div>
                        </div>
                        <DataTable
                          className="my-custom-table"
                          columns={columns}
                          data={filteredData}
                          progressPending={isLoadingTable}
                          pagination
                          paginationResetDefaultPage={false}
                          progressComponent={
                            <Spinner color="primary" style={{ height: "3rem", width: "3rem" }} type="grow">
                              Loading...
                            </Spinner>
                          }
                          subHeader={false}
                          persistTableHead
                          striped
                          responsive
                          highlightOnHover
                          paginationRowsPerPageOptions={[25, 50, 100, 500]}
                          paginationPerPage={25}
                        />
                      </div>
                    </Block>
                  )}
                  {/* {activeTab == "slots" && (
                    <Block>
                      <BlockHead>
                        <BlockTitle tag="h5">Slots</BlockTitle>
                      </BlockHead>
                    </Block>
                  )} */}
                </div>
              </div>

              <Sidebar toggleState={sideBar}>
                <div className="card-inner">
                  <div className="user-card user-card-s2 mt-5 mt-xxl-0">
                    {/* <UserAvatar className="lg" theme="primary" text={getSmartInitials(doctor?.name)} /> */}
                    <UserAvatar
                      theme={doctor?.avatarBg}
                      className="md"
                      text={findUpper(doctor?.name)}
                      image={doctor?.image}
                    >
                      <div className="status dot dot-lg dot-success"></div>
                    </UserAvatar>
                    <div className="user-info">
                      <Badge color="outline-light" pill className="ucap">
                        {doctor?.role || "Doctor"}
                      </Badge>
                      <h5 className="text-capitalize">{doctor?.name}</h5>
                      <span className="sub-text">{doctor?.email}</span>
                    </div>
                  </div>
                </div>
                <div className="card-inner card-inner-sm">
                  <ul className="btn-toolbar justify-center gx-1">
                    <li>
                      <Button
                        href="#star"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                        className={`btn-trigger btn-icon ${doctor?.isSelected ? "text-primary" : ""}`}
                        id={`feature-doctor`}
                      >
                        <Icon name={doctor?.isSelected ? "star-fill" : "star"}></Icon>
                      </Button>
                      <TooltipComponent
                        iconClass="card-hint"
                        direction="top"
                        id={`feature-doctor`}
                        text={`This doctor is ${doctor?.isSelected ? "in featured" : "not in featured"} list.`}
                      />
                    </li>
                    {/* <li>
                      <Button
                        href="#download"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                        className="btn-trigger btn-icon"
                      >
                        <Icon name="download-cloud"></Icon>
                      </Button>
                    </li> */}

                    <li>
                      <Button
                        href="#cancel"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                        className="btn-trigger btn-icon text-danger"
                        id={`block-doctor`}
                      >
                        <Icon name="na"></Icon>
                      </Button>
                      <TooltipComponent
                        iconClass="card-hint"
                        direction="top"
                        id={`block-doctor`}
                        text="Block doctor."
                      />
                    </li>
                  </ul>
                </div>
                {/* <div className="card-inner">
                  <div className="overline-title-alt mb-2">In Account</div>
                  <div className="profile-balance">
                    <div className="profile-balance-group gx-4">
                      <div className="profile-balance-sub">
                        <div className="profile-balance-amount">
                          <div className="number">
                            2,500.00 <small className="currency currency-usd">INR</small>
                          </div>
                        </div>
                        <div className="profile-balance-subtitle">Referral Amount</div>
                      </div>
                      <div className="profile-balance-sub">
                        <span className="profile-balance-plus text-soft">
                          <Icon className="ni-plus"></Icon>
                        </span>
                        <div className="profile-balance-amount">
                          <div className="number">1,643.76</div>
                        </div>
                        <div className="profile-balance-subtitle">Profit Earned</div>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="card-inner">
                  <Row className="text-center">
                    <Col size="4">
                      <div className="profile-stats">
                        <span className="amount text-primary">{doctor?.totalAppointments || 0}</span>
                        <span className="sub-text">Appointment</span>
                      </div>
                    </Col>
                    <Col size="4">
                      <div className="profile-stats">
                        <span className="amount text-primary">{doctor?.completed || 0}</span>
                        <span className="sub-text">Complete</span>
                      </div>
                    </Col>
                    <Col size="4">
                      <div className="profile-stats">
                        <span className="amount text-primary">{doctor?.pending || 0}</span>
                        <span className="sub-text">Pending</span>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="card-inner">
                  <OverlineTitle tag="h6" className="">
                    Specialization
                  </OverlineTitle>
                  <ul className="g-1">
                    {/* {doctor?.specialization?.map((item, index) => ( */}
                    <li className="btn-group flex-wrap">
                      {/* <Button
                        color="light"
                        size="xs"
                        className="btn-dim"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                      > */}
                      {doctor?.specialization?.map((spec) => (
                        <Badge
                          key={spec}
                          className="me-1 mb-1 text-capitalize"
                          color="gray"
                          style={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                            // maxWidth: "150px", // optional (control width)
                          }}
                        >
                          {spec}
                        </Badge>
                      ))}
                      {/* </Button> */}
                      {/* <Button
                        color="light"
                        size="xs"
                        className="btn-icon btn-dim"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                      >
                        <Icon className="ni-cross"></Icon>
                      </Button> */}
                    </li>
                    {/* ))} */}
                  </ul>
                </div>
              </Sidebar>
            </div>
          </Card>
        </Block>
      </Content>
    </>
  );
};

export default DoctorDetailsView;
